import type {PromotionCycle} from '../../types';

import DiscountSection from '../common/DiscountSection/DiscountSection';
import LiveDiscountCard from './components/LiveDiscountCard/LiveDiscountCard';

type ActiveDiscountProps = {
  cycle: PromotionCycle;
  onClick: () => void;
};

const ActiveDiscount: React.FC<ActiveDiscountProps> = ({cycle, onClick}) => {
  return (
    <DiscountSection title="تخفیف فعال">
      <LiveDiscountCard cycle={cycle} onClick={onClick} />
    </DiscountSection>
  );
};

export default ActiveDiscount;
